// src/store/sessionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
};

const refreshSlice = createSlice({
  name: 'refresh',
  initialState,
  reducers: {
    setRefreshToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('refresh_token', action.payload); // Store token in localStorage
    },
    clearRefreshToken: (state) => {
      state.token = null;
      localStorage.removeItem('refresh_token'); // Clear token from localStorage
    },
  },
});

export const { setSessionToken, clearRefreshToken } = refreshSlice.actions;

export const selectRefreshToken = (state) => state.refresh.token;

export default refreshSlice.reducer;
